export enum ScreenEnum {
  'welcome' = 'WelcomeScreen',
  'chart' = 'ChartScreen',
  'createProfile' = 'CreateProfile',
  'enterProfile' = 'EnterProfile',
}
